import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { NgbDropdownModule, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ExpanderComponent } from '../expander/expander.component';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { Dialog } from '@angular/cdk/dialog';
import { of } from 'rxjs';
import { NotificationsComponent } from '../notifications/notifications.component';
import { mainConfiguration } from '../../../configuration/main';
import { UserMenuComponent } from '../user-menu/user-menu.component';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationService } from '../../services/authentication.service';
import { HelpService } from '../../../services/help.service';

@Component({
  selector: 'adf-global-application-toolbar',
  standalone: true,
  imports: [
    CommonModule,
    NgbDropdownModule,
    NgbTooltip,
    ExpanderComponent,
    NotificationsComponent,
    UserMenuComponent,
    RouterLink,
  ],
  templateUrl: './global-application-toolbar.component.html',
  styleUrl: './global-application-toolbar.component.scss',
})
export class GlobalApplicationToolbarComponent implements OnInit {
  private readonly _router = inject(Router);
  private readonly _destroyRef = inject(DestroyRef);
  private readonly _activatedRoute = inject(ActivatedRoute);
  private readonly _dialog = inject(Dialog);
  private readonly _msalService = inject(MsalService);
  private readonly _authService = inject(AuthenticationService);
  private readonly router = inject(Router);
  private readonly _helpService = inject(HelpService);

  helpOpen$ = this._helpService.isOpen$;

  isNotError$ = of(true);
  isSettingsLoaded = false;
  title = mainConfiguration.title;

  ngOnInit() {}

  onLogout() {
    this._authService.logout();
  }

  toggleHelp() {
    this._helpService.toggle();
  }

  getCurrentUser() {
    return this._authService.getCurrentUser();
  }

  getUsername(): string {
    return this.getCurrentUser()?.name ?? '';
  }

  getEmail(): string {
    return this.getCurrentUser()?.username ?? '';
  }

  isHome(): boolean {
    return this.router.url === '/' || this.router.url === '/calculations/list';
  }
}
